module.exports = __webpack_public_path__ + "assets/img/blog-details.7ac6eb62.png";